import { sendBrazeAuctionEvent, sendBrazeBuyItNowEvent, sendBrazeShortlistEvent } from 'Services/braze/brazeEvents';
import type { Pagination } from 'Types/pagination';
import { LIST_TYPES } from 'Utilities/consts';

export const DEFAULT_PAGINATION: Pagination = {
	hasMore: false,
	page: 0,
	touched: false,
};

export const EMPTY_VEHICLES_RESPONSE = {
	pagination: DEFAULT_PAGINATION,
	totalCount: 0,
	vehicles: [],
};

export const LIST_TYPE_BRAZE_DICT = {
	[LIST_TYPES.auction]: sendBrazeAuctionEvent,
	[LIST_TYPES.buyItNow]: sendBrazeBuyItNowEvent,
	[LIST_TYPES.shortlist]: sendBrazeShortlistEvent,
	// eslint-disable-next-line no-empty-function
	[LIST_TYPES.aiCompanion]: () => Promise.resolve(undefined),
};
